module.exports = __webpack_public_path__ + "img/Layer-8.dd8e9369.webp";